import React from "react";
import Link from "next/link";
import exam from "@_fakeData/exam-list.json";
import styles from "./styles/exam_preparation_list.module.scss";
import { Grid } from "@mui/material";
import Image from "next/legacy/image";
import { getAssets } from "@unisearch/helpers";

const ExamPreparationLists = () => {
  return (
    <section className={styles.wrapper}>
      <div className="container">
        <h2>Exams Preparation</h2>
        <p>
          From English language proficiency test scores to aptitude tests like
          the GMAT and GRE, we have you covered to get your skills where they
          need to be to ace your university applications.
        </p>
        <Grid
          container
          spacing={{ xs: 2, sm: 2, md: 4 }}
          justifyContent="center"
        >
          {exam.map((item, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Link legacyBehavior href={item?.link}>
                <a>
                  <div className={styles.card}>
                    {/* <img src={item.img} alt={item.title} /> */}
                    <Image
                      layout="responsive"
                      width={366}
                      height={284}
                      blurDataURL={getAssets(
                        "assets/images/study/country_placeholder.webp"
                      )}
                      placeholder="blur"
                      src={
                        item.img ||
                        getAssets("/assets/images/image_placeholder_big.webp")
                      }
                      alt={item.title || "exam preoaration"}
                    />
                    <div className={styles.detail}>
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </div>
                  </div>
                </a>
              </Link>
            </Grid>
          ))}
        </Grid>
      </div>
    </section>
  );
};

export default ExamPreparationLists;
